<template>
  <hi-dialog v-model="open" persist :close-button="false" slim-footer>
    <slot />
    <div style="width: 30%; min-width: 300px"></div>
    <template v-slot:footer>
      <div class="w-full flex-center">
        <hi-button @click="ok" primary class="w-16">OK</hi-button>
      </div>
    </template>
  </hi-dialog>
</template>

<script>
import HiButton from "../HiButton";
import HiDialog from "./HiDialog";
import modelRef from "@/hive-vue3/utils/reactiveHelpers/modelRef";
export default {
  name: "HiAlert",
  components: { HiDialog, HiButton },
  props: {
    modelValue: {
      Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "ok"],
  setup(props, context) {
    const open = modelRef(props, context.emit);
    function ok() {
      context.emit("ok");
      // context.emit("update:modelValue", false);
      open.value = false;
    }
    return {
      // clickBg,
      ok,
      open,
    };
  },
};
</script>

<style scoped></style>
